// ----------------------------------------------------------------------

export default function Autocomplete(theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z20,
          borderRadius: 16,
          border: '1px solid #ECEEF1',
        },
      },
    },
  };
}
